import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { t } from "@/i18n/sk";
import { getEra, resolveImg } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { HoloBackground } from "@/components/HoloBackground";

export default function EraDetail() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setData(null); setNotFound(false);
    getEra(slug).then(setData).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="vault-bg mx-auto max-w-3xl px-4 py-32 text-center"><h1 className="font-display text-3xl font-bold text-white">Éra nenájdená</h1><Link to="/serie" className="mt-6 inline-block text-cyan-300">← {t.nav.series}</Link></div>;

  const era = data?.era;
  const expansions = data?.expansions || [];
  const products = data?.products || [];

  return (
    <div className="vault-bg">
      <section className="relative overflow-hidden border-b border-white/8">
        <div className="absolute inset-0">
          {era?.image_url && <img src={resolveImg(era.image_url)} alt="" className="h-full w-full object-cover opacity-25" />}
          <div className="absolute inset-0 bg-gradient-to-t from-vault-black via-vault-midnight/80 to-vault-black/50" />
        </div>
        <HoloBackground />
        <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
          <Link to="/serie" className="mb-6 inline-flex items-center gap-1.5 text-sm text-slate-300 hover:text-white"><ArrowLeft className="h-4 w-4" /> {t.nav.series}</Link>
          {era && (
            <>
              <span className="overline mb-3 block">Éra</span>
              <h1 className="font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">{era.name}</h1>
              <p className="mt-4 max-w-2xl text-slate-300">{era.description}</p>
            </>
          )}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        {expansions.length > 0 && (
          <>
            <h2 className="mb-6 font-display text-xl font-bold text-white">Série v tejto ére</h2>
            <div className="mb-14 flex flex-wrap gap-3">
              {expansions.map((exp) => (
                <Link key={exp.id} to={`/serie/${exp.slug}`} data-testid={`era-series-${exp.slug}`} className="inline-flex items-center gap-2 rounded-full border border-white/12 bg-vault-card px-4 py-2 text-sm font-medium text-white transition-colors hover:border-violet-glow/50">
                  {exp.name} <ArrowRight className="h-3.5 w-3.5 text-cyan-300" />
                </Link>
              ))}
            </div>
          </>
        )}

        {products.length > 0 ? (
          <>
            <h2 className="mb-6 font-display text-xl font-bold text-white">{t.catalog.results(products.length)}</h2>
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
            </div>
          </>
        ) : (
          <p className="py-10 text-center text-slate-400">V tejto ére zatiaľ nie sú produkty.</p>
        )}
      </section>
    </div>
  );
}
